/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:706a5384-0bb3-4fa3-a642-39c373225d4d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_EiExhXEzH",
    "aws_user_pools_web_client_id": "6g256mvsirs9db0rkei0ablg06",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "phi-vitruvian2358",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "build_in_creds": true,
};

export default awsmobile;
